import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-Factors-Prop-Value',
    templateUrl: './Factors-Prop-Value.component.html',
    styleUrls: ['./Factors-Prop-Value.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FactorsPropValueComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
